import type { ContactDetailsGet } from "@/domain/contactdetails/getContactDetails"
import { isNotBlank, isNullOrUndefined } from "@/utils/ts-utils"

type Props = {
  contactDetails?: ContactDetailsGet
  dft?: string
}

export const ContactDetailsAddress: React.FC<Props> = ({ contactDetails, dft }) => {
  if (isNullOrUndefined(contactDetails)) return <>{dft ?? ""}</>

  const address: string[] = []

  if (isNotBlank(contactDetails.address1)) address.push(contactDetails.address1)
  if (isNotBlank(contactDetails.address2)) address.push(contactDetails.address2)
  if (isNotBlank(contactDetails.address3)) address.push(contactDetails.address3)

  const row: string[] = []
  if (isNotBlank(contactDetails.zipcode)) row.push(contactDetails.zipcode)
  if (isNotBlank(contactDetails.city)) row.push(contactDetails.city)
  if (isNotBlank(contactDetails.country)) row.push(contactDetails.country)
  if (row.length > 0) address.push(row.join(" "))

  return (
    <>
      {address.map((line, i) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
        <p key={i}>{line}</p>
      ))}
    </>
  )
}
